import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import "../../../style/style-cargando.css";
import cargandoCard from "../../../components/cargando-card";
import moment from "moment/moment";
import LoadingComponent from "../../../components/loading-component";
import { compressAndConvertToBase64 } from "../../../utils/shared-functions";
import { deshabilitarImagenPublicidad, guardarImagenPublicidad, obtenerImagenPublicidad } from "../../../api/api-publicidad";
import { INT_HORIZONTAL_IMAGE, INT_VERTICAL_IMAGE } from "../../../utils/const/int-const";

export default function Publicidad() {
    const location = useLocation();
    const history = useHistory();
    const [popUpLoadingVisible, setPopUpLoadingVisible] = useState(false);
    const [title, setTitle] = useState("");
    const [cargandoPage, setCargandoPage] = useState(true);
    const [formData, setFormData] = useState({
        id: 0,
        whatsappNumber: "",
        urlTikTok: "",
        urlFacebook: "",
        urlInstagram: "",
        urlTwitter: "",
        urlYoutube: "",
        urlPaginaWeb: "",
        nota: "",
    });
    const [images320x1080, setImages320x1080] = useState([]);
    const [images240x900, setImages240x900] = useState([]);
    const [images213x720, setImages213x720] = useState([]);

    const [images768X120, setImages768X120] = useState([]);
    const [images1024X120, setImages1024X120] = useState([]);
    const [images1440X120, setImages1440X120] = useState([]);

    const verticalSizes = {
        3201080: "320x1080",
        240900: "240x900",
        213720: "213x720",
    };

    const horizontalSizes = {
        768120: "768X120",
        1024120: "1024X120",
        1440120: "1440X120",
    };

    useEffect(() => {
        iniciar();
    }, []);

    const iniciar = async () => {
        try {
            const response = await obtenerImagenPublicidad();
            // console.log('response');
            // console.log(response);
            if (Array.isArray(response.body)) {
                setImages320x1080(response.body.filter((img) => img.idSize === INT_VERTICAL_IMAGE.BIG));
                setImages240x900(response.body.filter((img) => img.idSize === INT_VERTICAL_IMAGE.MEDIUM));
                setImages213x720(response.body.filter((img) => img.idSize === INT_VERTICAL_IMAGE.SMALL));

                setImages1440X120(response.body.filter((img) => img.idSize === INT_HORIZONTAL_IMAGE.BIG));
                setImages1024X120(response.body.filter((img) => img.idSize === INT_HORIZONTAL_IMAGE.MEDIUM));
                setImages768X120(response.body.filter((img) => img.idSize === INT_HORIZONTAL_IMAGE.SMALL));
            }
            setCargandoPage(false);
        } catch (err) {
            console.log('iniciar err');
            console.log(err);
            setCargandoPage(false);
        }
    };

    const handleAtrasClick = () => {
        history.goBack();
    };

    /**320x1080 */
    const handleDrop320_1080 = (event) => {
        event.preventDefault();
        const file = event.dataTransfer.files[0];
        if (file) {
            convertToBase64(file, verticalSizes["3201080"]);
        }
    };

    const handleFileSelect320_1080 = (event) => {
        if (!event.target.files) {
            console.error("No files detected in event.target.files.");
            return;
        }

        const file = event.target.files[0];

        if (file) {
            convertToBase64(file, verticalSizes["3201080"]);
        } else {
            console.error("No file selected.");
        }
    };

    /**240x900 */
    const handleDrop240_900 = (event) => {
        event.preventDefault();
        const file = event.dataTransfer.files[0];
        if (file) {
            convertToBase64(file, verticalSizes["240900"]);
        }
    };

    const handleFileSelect240_900 = (event) => {
        if (!event.target.files) {
            console.error("No files detected in event.target.files.");
            return;
        }

        const file = event.target.files[0];

        if (file) {
            convertToBase64(file, verticalSizes["240900"]);
        } else {
            console.error("No file selected.");
        }
    };
    /**213x720 */
    const handleDrop213_720 = (event) => {
        event.preventDefault();
        const file = event.dataTransfer.files[0];
        if (file) {
            convertToBase64(file, verticalSizes["213720"]);
        }
    };

    const handleFileSelect213_720 = (event) => {
        if (!event.target.files) {
            console.error("No files detected in event.target.files.");
            return;
        }

        const file = event.target.files[0];

        if (file) {
            convertToBase64(file, verticalSizes["213720"]);
        } else {
            console.error("No file selected.");
        }
    };

    /** 1440X120 */
    const handleDrop1440_120 = (event) => {
        event.preventDefault();
        const file = event.dataTransfer.files[0];
        if (file) {
            convertToBase64(file, horizontalSizes["1440120"]);
        }
    };

    const handleFileSelect1440_120 = (event) => {
        if (!event.target.files) {
            console.error("No files detected in event.target.files.");
            return;
        }

        const file = event.target.files[0];

        if (file) {
            convertToBase64(file, horizontalSizes["1440120"]);
        } else {
            console.error("No file selected.");
        }
    };
    /** 1024X120 */
    const handleDrop1024_120 = (event) => {
        event.preventDefault();
        const file = event.dataTransfer.files[0];
        if (file) {
            convertToBase64(file, horizontalSizes["1024120"]);
        }
    };

    const handleFileSelect1024_120 = (event) => {
        if (!event.target.files) {
            console.error("No files detected in event.target.files.");
            return;
        }

        const file = event.target.files[0];

        if (file) {
            convertToBase64(file, horizontalSizes["1024120"]);
        } else {
            console.error("No file selected.");
        }
    };

    /** 768X120 */

    const handleDrop768_120 = (event) => {
        event.preventDefault();
        const file = event.dataTransfer.files[0];
        if (file) {
            convertToBase64(file, horizontalSizes["768120"]);
        }
    };

    const handleFileSelect768_120 = (event) => {
        if (!event.target.files) {
            console.error("No files detected in event.target.files.");
            return;
        }

        const file = event.target.files[0];

        if (file) {
            convertToBase64(file, horizontalSizes["768120"]);
        } else {
            console.error("No file selected.");
        }
    };

    // Convert image file to Base64
    const convertToBase64 = (file, imageSize) => {
        const MAX_SIZE = 5 * 1024 * 1024; // 1MB in bytes

        if (file.size > MAX_SIZE) {
            alert("The image is bigger than the allowed size (" + MAX_SIZE + "MB). Please select a smaller file.");
            return;
        }
        compressAndConvertToBase64(file, (base64String) => {
            uploadImage(base64String, imageSize);
        });
    };

    const uploadImage = async (file, imageSize) => {
        try {
            // console.log('uploadImage');
            // console.log(file);
            // console.log('imageSize', imageSize);
            let sizeImage = "";
            switch (imageSize) {
                case verticalSizes["3201080"]:
                    sizeImage = INT_VERTICAL_IMAGE.BIG;
                    if (images320x1080.length > 5) {
                        alert("No se puede agregar mas de 5 imagenes");
                        return;
                    }
                    break;
                case verticalSizes["240900"]:
                    sizeImage = INT_VERTICAL_IMAGE.MEDIUM;
                    if (images240x900.length > 5) {
                        alert("No se puede agregar mas de 5 imagenes");
                        return;
                    }
                    break;
                case verticalSizes["213720"]:
                    sizeImage = INT_VERTICAL_IMAGE.SMALL;
                    if (images213x720.length > 5) {
                        alert("No se puede agregar mas de 5 imagenes");
                        return;
                    }
                    break;
                case horizontalSizes["1440120"]:
                    sizeImage = INT_HORIZONTAL_IMAGE.BIG;
                    if (images1440X120.length > 5) {
                        alert("No se puede agregar mas de 5 imagenes");
                        return;
                    }
                    break;
                case horizontalSizes["1024120"]:
                    sizeImage = INT_HORIZONTAL_IMAGE.MEDIUM;
                    if (images1024X120.length > 5) {
                        alert("No se puede agregar mas de 5 imagenes");
                        return;
                    }
                    break;
                case horizontalSizes["768120"]:
                    sizeImage = INT_HORIZONTAL_IMAGE.SMALL;
                    if (images768X120.length > 5) {
                        alert("No se puede agregar mas de 5 imagenes");
                        return;
                    }
                    break;
                default:
                    alert('imageSize not recognized', imageSize);
                    return;
            }
            setPopUpLoadingVisible(true);
            let objEnviar = {};
            objEnviar.base64 = file;
            objEnviar.nombre = moment().unix() + '.png';
            objEnviar.tipoArchivo = ".png";
            objEnviar.sizeImage = sizeImage;
            const response = await guardarImagenPublicidad(objEnviar);
            // console.log('response');
            // console.log(response);
            if (response.error === false) {
                // console.log('imageSize', imageSize);
                // console.log('image', sizes["3201080"]);
                switch (imageSize) {
                    case verticalSizes["3201080"]:
                        setImages320x1080([...images320x1080, { id: response.body.id, urlImagen: response.body.urlImagen }]);
                        break;
                    case verticalSizes["240900"]:
                        setImages240x900([...images240x900, { id: response.body.id, urlImagen: response.body.urlImagen }]);
                        break;
                    case verticalSizes["213720"]:
                        setImages213x720([...images213x720, { id: response.body.id, urlImagen: response.body.urlImagen }]);
                        break;

                    case horizontalSizes["1440120"]:
                        setImages1440X120([...images1440X120, { id: response.body.id, urlImagen: response.body.urlImagen }]);
                        break;
                    case horizontalSizes["1024120"]:
                        setImages1024X120([...images1024X120, { id: response.body.id, urlImagen: response.body.urlImagen }]);
                        break;
                    case horizontalSizes["768120"]:
                        setImages768X120([...images768X120, { id: response.body.id, urlImagen: response.body.urlImagen }]);
                        break;
                    default:
                        console.log('imageSize not recognized', imageSize);
                        break;
                }
            } else {
                alert("Upload failed");
            }
            setPopUpLoadingVisible(false);
        } catch (error) {
            console.error("Error uploading image:", error);
            setPopUpLoadingVisible(false);
        }
    };

    /** VERTICAL */
    const deleteImage320_1080 = async (image) => {
        try {
            // console.log('images320x1080', images320x1080);
            // setImages320x1080(images320x1080.filter((img) => img !== image));
            const confirmed = window.confirm("Seguro que desea eliminar imagen?");
            if (confirmed) {
                setPopUpLoadingVisible(true);
                let objEnviar = {};
                objEnviar.id = image.id;
                const response = await deshabilitarImagenPublicidad(objEnviar);
                // console.log('response');
                // console.log(response);
                setPopUpLoadingVisible(false);
                if (response.error === false) {
                    setImages320x1080(images320x1080.filter((img) => img.id !== image.id));
                }
                if (response.error === true) {
                    alert('No se pudo eliminar la imagen\n' + response.message);
                }
            }
        } catch (error) {
            console.error("Error deleting image:", error);
        }
    };

    const deleteImage240_900 = async (image) => {
        try {
            // setImages240x900(images240x900.filter((img) => img !== imageUrl));
            const confirmed = window.confirm("Seguro que desea eliminar imagen?");
            if (confirmed) {
                setPopUpLoadingVisible(true);
                let objEnviar = {};
                objEnviar.id = image.id;
                const response = await deshabilitarImagenPublicidad(objEnviar);
                // console.log('response');
                // console.log(response);
                setPopUpLoadingVisible(false);
                if (response.error === false) {
                    setImages240x900(images240x900.filter((img) => img.id !== image.id));
                }
                if (response.error === true) {
                    alert('No se pudo eliminar la imagen\n' + response.message);
                }
            }
        } catch (error) {
            console.error("Error deleting image:", error);
        }
    };

    const deleteImage213_720 = async (image) => {
        try {
            // setImages213x720(images213x720.filter((img) => img !== imageUrl));
            const confirmed = window.confirm("Seguro que desea eliminar imagen?");
            if (confirmed) {
                setPopUpLoadingVisible(true);
                let objEnviar = {};
                objEnviar.id = image.id;
                const response = await deshabilitarImagenPublicidad(objEnviar);
                // console.log('response');
                // console.log(response);
                setPopUpLoadingVisible(false);
                if (response.error === false) {
                    setImages213x720(images213x720.filter((img) => img.id !== image.id));
                }
                if (response.error === true) {
                    alert('No se pudo eliminar la imagen\n' + response.message);
                }
            }
        } catch (error) {
            console.error("Error deleting image:", error);
        }
    };

    /** HORIZONTAL */
    const deleteImage1440_120 = async (image) => {
        try {
            const confirmed = window.confirm("Seguro que desea eliminar imagen?");
            if (confirmed) {
                setPopUpLoadingVisible(true);
                let objEnviar = {};
                objEnviar.id = image.id;
                const response = await deshabilitarImagenPublicidad(objEnviar);
                // console.log('response');
                // console.log(response);
                setPopUpLoadingVisible(false);
                if (response.error === false) {
                    setImages1440X120(images1440X120.filter((img) => img.id !== image.id));
                }
                if (response.error === true) {
                    alert('No se pudo eliminar la imagen\n' + response.message);
                }
            }
        } catch (error) {
            console.error("Error deleting image:", error);
        }
    };

    const deleteImage1024_120 = async (image) => {
        try {
            // setImages240x900(images240x900.filter((img) => img !== imageUrl));
            const confirmed = window.confirm("Seguro que desea eliminar imagen?");
            if (confirmed) {
                setPopUpLoadingVisible(true);
                let objEnviar = {};
                objEnviar.id = image.id;
                const response = await deshabilitarImagenPublicidad(objEnviar);
                // console.log('response');
                // console.log(response);
                setPopUpLoadingVisible(false);
                if (response.error === false) {
                    setImages1024X120(images1024X120.filter((img) => img.id !== image.id));
                }
                if (response.error === true) {
                    alert('No se pudo eliminar la imagen\n' + response.message);
                }
            }
        } catch (error) {
            console.error("Error deleting image:", error);
        }
    };

    const deleteImage768_120 = async (image) => {
        try {
            // setImages213x720(images213x720.filter((img) => img !== imageUrl));
            const confirmed = window.confirm("Seguro que desea eliminar imagen?");
            if (confirmed) {
                setPopUpLoadingVisible(true);
                let objEnviar = {};
                objEnviar.id = image.id;
                const response = await deshabilitarImagenPublicidad(objEnviar);
                // console.log('response');
                // console.log(response);
                setPopUpLoadingVisible(false);
                if (response.error === false) {
                    setImages768X120(images768X120.filter((img) => img.id !== image.id));
                }
                if (response.error === true) {
                    alert('No se pudo eliminar la imagen\n' + response.message);
                }
            }
        } catch (error) {
            console.error("Error deleting image:", error);
        }
    };

    const render = () => {
        try {
            if (cargandoPage === true) {
                return cargandoCard();
            }
            if (cargandoPage === false && formData === null) {
                return (
                    <div>
                        <label> Sin data</label>
                    </div>
                );
            }
            return (
                <div className="p-4">
                    <h2 className="text-2xl font-bold text-[#0F3457] mb-6">{title}</h2>
                    <div className="grid grid-cols-12 gap-4">
                        <label>320×1080</label>
                        <div className="col-span-12">
                            <div className="max-w-lg mx-auto p-6">
                                {/* Drag and Drop Area */}
                                <div
                                    className="border-2 border-dashed border-gray-400 p-10 text-center cursor-pointer"
                                    onDrop={handleDrop320_1080}
                                    onDragOver={(e) => e.preventDefault()}
                                >
                                    <p className="text-gray-600">Drag & Drop an image or</p>
                                    <input type="file" className="hidden" onChange={handleFileSelect320_1080} id="fileInput" />
                                    <label htmlFor="fileInput" className="bg-blue-500 text-white px-4 py-2 rounded cursor-pointer mt-2 inline-block">
                                        Select File
                                    </label>
                                </div>

                                {/* Uploaded Images List */}
                                <div className="mt-4">
                                    {images320x1080.map((image, index) => (
                                        <div key={index} className="flex items-center justify-between p-2 border rounded mt-2">
                                            <img src={image.urlImagen} alt="Uploaded" className="w-16 h-16 object-cover rounded" />
                                            <button className="bg-red-500 text-white px-2 py-1 rounded" onClick={() => deleteImage320_1080(image)}>
                                                Delete
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="grid grid-cols-12 gap-4">
                        <label>240x900</label>
                        <div className="col-span-12">
                            <div className="max-w-lg mx-auto p-6">
                                {/* Drag and Drop Area */}
                                <div
                                    className="border-2 border-dashed border-gray-400 p-10 text-center cursor-pointer"
                                    onDrop={handleDrop240_900}
                                    onDragOver={(e) => e.preventDefault()}
                                >
                                    <p className="text-gray-600">Drag & Drop an image or</p>
                                    <input type="file" className="hidden" onChange={handleFileSelect240_900} id="fileInput" />
                                    <label htmlFor="fileInput" className="bg-blue-500 text-white px-4 py-2 rounded cursor-pointer mt-2 inline-block">
                                        Select File
                                    </label>
                                </div>

                                {/* Uploaded Images List */}
                                <div className="mt-4">
                                    {images240x900.map((image, index) => (
                                        <div key={index} className="flex items-center justify-between p-2 border rounded mt-2">
                                            <img src={image.urlImagen} alt="Uploaded" className="w-16 h-16 object-cover rounded" />
                                            <button className="bg-red-500 text-white px-2 py-1 rounded" onClick={() => deleteImage240_900(image)}>
                                                Delete
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="grid grid-cols-12 gap-4">
                        <label>213×720</label>
                        <div className="col-span-12">
                            <div className="max-w-lg mx-auto p-6">
                                {/* Drag and Drop Area */}
                                <div
                                    className="border-2 border-dashed border-gray-400 p-10 text-center cursor-pointer"
                                    onDrop={handleDrop213_720}
                                    onDragOver={(e) => e.preventDefault()}
                                >
                                    <p className="text-gray-600">Drag & Drop an image or</p>
                                    <input type="file" className="hidden" onChange={handleFileSelect213_720} id="fileInput" />
                                    <label htmlFor="fileInput" className="bg-blue-500 text-white px-4 py-2 rounded cursor-pointer mt-2 inline-block">
                                        Select File
                                    </label>
                                </div>

                                {/* Uploaded Images List */}
                                <div className="mt-4">
                                    {images213x720.map((image, index) => (
                                        <div key={index} className="flex items-center justify-between p-2 border rounded mt-2">
                                            <img src={image.urlImagen} alt="Uploaded" className="w-16 h-16 object-cover rounded" />
                                            <button className="bg-red-500 text-white px-2 py-1 rounded" onClick={() => deleteImage213_720(image)}>
                                                Delete
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    {/* <div className="grid grid-cols-12 gap-4">
                        <label>1440×120</label>
                        <div className="col-span-12">
                            <div className="max-w-lg mx-auto p-6">
                                <div
                                    className="border-2 border-dashed border-gray-400 p-10 text-center cursor-pointer"
                                    onDrop={handleDrop1440_120}
                                    onDragOver={(e) => e.preventDefault()}
                                >
                                    <p className="text-gray-600">Drag & Drop an image or</p>
                                    <input type="file" className="hidden" onChange={handleFileSelect1440_120} id="fileInput" />
                                    <label htmlFor="fileInput" className="bg-blue-500 text-white px-4 py-2 rounded cursor-pointer mt-2 inline-block">
                                        Select File
                                    </label>
                                </div>

                                
                                <div className="mt-4">
                                    {images1440X120.map((image, index) => (
                                        <div key={index} className="flex items-center justify-between p-2 border rounded mt-2">
                                            <img src={image.urlImagen} alt="Uploaded" className="w-16 h-16 object-cover rounded" />
                                            <button className="bg-red-500 text-white px-2 py-1 rounded" onClick={() => deleteImage1440_120(image)}>
                                                Delete
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="grid grid-cols-12 gap-4">
                        <label>1024×120</label>
                        <div className="col-span-12">
                            <div className="max-w-lg mx-auto p-6">
                                
                    <div
                        className="border-2 border-dashed border-gray-400 p-10 text-center cursor-pointer"
                        onDrop={handleDrop1024_120}
                        onDragOver={(e) => e.preventDefault()}
                    >
                        <p className="text-gray-600">Drag & Drop an image or</p>
                        <input type="file" className="hidden" onChange={handleFileSelect1024_120} id="fileInput" />
                        <label htmlFor="fileInput" className="bg-blue-500 text-white px-4 py-2 rounded cursor-pointer mt-2 inline-block">
                            Select File
                        </label>
                    </div>

                    
                    <div className="mt-4">
                        {images1024X120.map((image, index) => (
                            <div key={index} className="flex items-center justify-between p-2 border rounded mt-2">
                                <img src={image.urlImagen} alt="Uploaded" className="w-16 h-16 object-cover rounded" />
                                <button className="bg-red-500 text-white px-2 py-1 rounded" onClick={() => deleteImage1024_120(image)}>
                                    Delete
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
                        </div >
                    </div > */}
                    <div className="grid grid-cols-12 gap-4">
                        <label>768×120</label>
                        <div className="col-span-12">
                            <div className="max-w-lg mx-auto p-6">
                                {/* Drag and Drop Area */}
                                <div
                                    className="border-2 border-dashed border-gray-400 p-10 text-center cursor-pointer"
                                    onDrop={handleDrop768_120}
                                    onDragOver={(e) => e.preventDefault()}
                                >
                                    <p className="text-gray-600">Drag & Drop an image or</p>
                                    <input type="file" className="hidden" onChange={handleFileSelect768_120} id="fileInput" />
                                    <label htmlFor="fileInput" className="bg-blue-500 text-white px-4 py-2 rounded cursor-pointer mt-2 inline-block">
                                        Select File
                                    </label>
                                </div>

                                {/* Uploaded Images List */}
                                <div className="mt-4">
                                    {images768X120.map((image, index) => (
                                        <div key={index} className="flex items-center justify-between p-2 border rounded mt-2">
                                            <img src={image.urlImagen} alt="Uploaded" className="w-16 h-16 object-cover rounded" />
                                            <button className="bg-red-500 text-white px-2 py-1 rounded" onClick={() => deleteImage768_120(image)}>
                                                Delete
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex justify-between">
                        <button
                            onClick={handleAtrasClick}
                            className="text-center text-[#0F3457] mt-4 cursor-pointer hover:underline"
                        >
                            Atras
                        </button>

                    </div>
                    <LoadingComponent
                        isOpen={popUpLoadingVisible}
                    />
                </div >
            );
        } catch (err) {
            console.log('Publicidad render err');
            console.log(err);
            return (
                <div>
                    <label>{JSON.stringify(err)}</label>
                </div>
            );
        }
    }

    return render();
}
